import {FC} from 'react'
import './social-links.scss'

const SocialLinks: FC = () => {
  return (
    <div className='social-container'>
      <p className='social-help'>Need help? Message a Helper on</p>
      <div className='social-links'>
        <a
          href='https://wa.me/your-number'
          className='whatsapp'
          target='_blank'
          rel='noopener noreferrer'
        >
          <i className='bi bi-chat-fill'></i>
          WhatsApp
        </a>
        <a
          href='https://facebook.com/your-page'
          className='facebook'
          target='_blank'
          rel='noopener noreferrer'
        >
          <i className='bi bi-chat-fill'></i>
          Facebook
        </a>
        <a
          href='https://instagram.com/your-profile'
          className='instagram'
          target='_blank'
          rel='noopener noreferrer'
        >
          <i className='bi bi-chat-fill gradient-instagram'></i>
          Instagram
        </a>
      </div>
    </div>
  )
}

export default SocialLinks
